export default __webpack_public_path__ + "static/media/lb-partner.3f47798d.jpeg";